var _style, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleCl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    style: {
      enableBackground: "new 0 0 73 73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 2.2858,
    x2: 36,
    y2: 72.455,
    gradientTransform: "matrix(1 0 0 -1 0 74.0068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FA233B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB5C74"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72,22.52c0-0.86,0-1.72,0-2.58c0-0.72-0.01-1.45-0.03-2.17c-0.04-1.58-0.14-3.17-0.42-4.73 c-0.28-1.58-0.75-3.06-1.48-4.5c-0.72-1.41-1.66-2.71-2.78-3.83s-2.42-2.06-3.83-2.78c-1.44-0.73-2.91-1.2-4.49-1.48 c-1.56-0.28-3.15-0.37-4.73-0.42C53.51,0.02,52.78,0.01,52.06,0c-0.86,0-1.72,0-2.58,0H22.52c-0.86,0-1.72,0-2.58,0 c-0.72,0-1.45,0.01-2.17,0.03c-1.58,0.04-3.17,0.14-4.73,0.42C11.46,0.74,9.98,1.2,8.55,1.94C7.13,2.66,5.84,3.6,4.72,4.72 S2.65,7.13,1.93,8.55c-0.73,1.44-1.2,2.91-1.48,4.5c-0.28,1.56-0.37,3.15-0.42,4.73C0.02,18.5,0.01,19.22,0,19.94 c0,0.86,0,1.72,0,2.58v26.95c0,0.86,0,1.72,0,2.58c0,0.72,0.01,1.45,0.03,2.17c0.04,1.58,0.14,3.17,0.42,4.73 c0.28,1.58,0.75,3.06,1.48,4.5c0.72,1.41,1.66,2.71,2.78,3.83c1.12,1.12,2.42,2.06,3.83,2.78c1.44,0.73,2.91,1.2,4.49,1.48 c1.56,0.28,3.15,0.37,4.73,0.42c0.72,0.02,1.45,0.03,2.17,0.03c0.86,0.01,1.72,0,2.58,0h26.95c0.86,0,1.72,0,2.58,0 c0.72,0,1.45-0.01,2.17-0.03c1.58-0.04,3.17-0.14,4.73-0.42c1.58-0.28,3.06-0.75,4.49-1.48c1.41-0.72,2.71-1.66,3.83-2.78 c1.12-1.12,2.06-2.41,2.78-3.83c0.73-1.44,1.2-2.91,1.48-4.5c0.28-1.56,0.37-3.15,0.42-4.73c0.02-0.72,0.03-1.45,0.03-2.17 c0.01-0.86,0-1.72,0-2.58L72,22.52L72,22.52z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Glyph_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,11c-0.17,0.02-1.72,0.29-1.91,0.33l-21.4,4.32l-0.01,0c-0.56,0.12-1,0.32-1.33,0.6 c-0.41,0.34-0.63,0.83-0.72,1.39c-0.02,0.12-0.05,0.36-0.05,0.72c0,0,0,21.86,0,26.78c0,0.63-0.05,1.23-0.47,1.75 c-0.42,0.52-0.95,0.67-1.56,0.8c-0.47,0.09-0.93,0.19-1.4,0.28c-1.77,0.36-2.92,0.6-3.96,1c-1,0.39-1.74,0.88-2.34,1.5 c-1.18,1.23-1.66,2.91-1.49,4.48c0.14,1.34,0.74,2.62,1.78,3.56c0.7,0.64,1.57,1.13,2.6,1.33c1.07,0.21,2.2,0.14,3.86-0.2 c0.88-0.18,1.71-0.46,2.5-0.92c0.78-0.46,1.45-1.07,1.97-1.82c0.52-0.75,0.86-1.58,1.05-2.47c0.19-0.91,0.24-1.74,0.24-2.65V28.56 c0-1.24,0.35-1.57,1.36-1.82c0,0,17.79-3.59,18.62-3.75c1.16-0.22,1.7,0.11,1.7,1.32v15.86c0,0.63-0.01,1.26-0.43,1.78 c-0.42,0.52-0.95,0.67-1.56,0.8c-0.47,0.09-0.93,0.19-1.4,0.28c-1.77,0.36-2.92,0.6-3.96,1c-1,0.39-1.74,0.88-2.34,1.5 c-1.18,1.23-1.7,2.91-1.53,4.48c0.14,1.34,0.78,2.62,1.82,3.56c0.7,0.64,1.57,1.11,2.6,1.32c1.07,0.21,2.2,0.14,3.86-0.2 c0.88-0.18,1.71-0.44,2.5-0.91c0.78-0.46,1.45-1.07,1.97-1.82c0.52-0.75,0.86-1.58,1.05-2.47c0.19-0.91,0.2-1.74,0.2-2.65V12.89 C52.71,11.66,52.06,10.9,50.9,11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCl);
export default __webpack_public_path__ + "static/media/apple_cl.a7f982347fc3f7cfe747f9b311d9df66.svg";
export { ForwardRef as ReactComponent };